import reframe from 'reframe.js'

export default () => {
  reframe('.text-block iframe')
  reframe('.js-fit-video iframe')
}
